import {Routes} from '@angular/router';
import {UserGuardService} from '@app/services/user-guard.service';

export const routes: Routes = [
    {
        path: '',
        loadChildren: () => import('./main/main.module').then(mod => mod.MainModule),
        canActivate: [UserGuardService],
    },
    {
        path: 'login',
        loadChildren: () => import('./login/login.module').then(mod => mod.LoginModule),
    },
    {
        path: '**',
        redirectTo: '',
    }
];
